/** Pretty labels + a stable color per raw EULP end-use. Keyed on the data value. */
export const EULP_LABELS: Record<string, string> = {
  cooling: "Cooling",
  heating: "Heating",
  fans: "Fans",
  pumps: "Pumps",
  heat_rejection: "Heat rejection",
  heat_recovery: "Heat recovery",
  interior_lighting: "Interior lighting",
  exterior_lighting: "Exterior lighting",
  plugs: "Plug loads",
  water_heating: "Water heating",
  refrigeration: "Refrigeration",
}

export const EULP_COLORS: Record<string, string> = {
  cooling: "#2563eb",
  heating: "#dc2626",
  fans: "#0891b2",
  pumps: "#7c3aed",
  heat_rejection: "#db2777",
  heat_recovery: "#ea580c",
  interior_lighting: "#ca8a04",
  exterior_lighting: "#a16207",
  plugs: "#059669",
  water_heating: "#0d9488",
  refrigeration: "#64748b",
}

export const enduseLabel = (e: string): string =>
  EULP_LABELS[e] ?? e.replace(/_/g, " ")

export const enduseColor = (e: string): string => EULP_COLORS[e] ?? "#94a3b8"
